module.exports = __webpack_public_path__ + "img/livingListIcon.5dc5217e.png";